import { all, call, take, put, select } from "redux-saga/effects";
import { devLog } from "../../utils/devLog";
import history from "../../history";

import {
  LOAD_PATIENTS,
  PATIENTS_LOADED,
  PATIENT_UPDATE,
  PATIENT_UPDATE_DONE,
  PATIENT_ADD_DONE,
  PATIENT_ADD,
  LOAD_PATIENT,
  LOAD_PATIENT_DONE,
  PATIENT_ADD_ERROR,
  LOAD_SAVED_SEARCHES,
  SAVED_SEARCHES_LOADED,
} from "../actions/actionTypes";

import PatientsService from "../../services/patientsService";

export function* addPatient() {
  while (true) {
    const action = yield take(PATIENT_ADD);
    yield put({ type: PATIENT_ADD });
    try {
      const result = yield PatientsService.add(action.data);
      devLog("ADD PATIENT ", result);
      yield put({ type: PATIENT_ADD_DONE, data: result });
      //history.push('/organizations/' + result.facilityId + '/patients');
    } catch (error) {
      devLog("ERROR", error);
      yield put({ type: PATIENT_ADD_ERROR, error });
    }
  }
}

export function* updatePatient() {
  while (true) {
    const action = yield take(PATIENT_UPDATE);
    try {
      const result = PatientsService.update(action.data);
      yield put({
        type: PATIENT_UPDATE_DONE,
        data: result,
      });
      history.push(`/facilities/${action.data.facilityId}/patients`);
    } catch (error) {
      devLog("ERROR", error);
    }
  }
}

export function* loadPatients() {
  while (true) {
    const action = yield take(LOAD_PATIENTS);
    //devLog("[patientsSaga] LOAD_PATIENTS action received:", action);
    //devLog("[patientsSaga] DETAILED CRITERIA DEBUG:", {
    //  hasSearchCriteria: !!action.searchCriteria,
    //  searchCriteria: action.searchCriteria,
    //  hasQueryId: !!action.searchCriteria?.queryId,
    //  queryIdValue: action.searchCriteria?.queryId,
    //  mode: action.searchCriteria?.mode,
    //  fullAction: action,
    //});

    // Helper function to get list type from criteria
    function getListTypeFromCriteria(criteria) {
      if (!criteria) return "all";
      if (criteria.queryId) return "savedQuery";
      if (criteria.statField || criteria.stat) return "dashboard";
      if (criteria.mode === "GETPATIENTS_TAGGED") return "watchlist";
      if (criteria.mode === "GETPATIENTS_ALL") return "all";
      if (criteria.mode === "GETPATIENTS_DASHBOARD") return "dashboard";
      return "all";
    }

    // Get the correct list state based on search criteria
    const patients = yield select((state) => state.patients);
    const listType = getListTypeFromCriteria(action.searchCriteria);
    const queryId = action.searchCriteria?.queryId;

    let currentListState;
    if (listType === "savedQuery" && queryId) {
      currentListState = patients.savedQuery[queryId] || {
        page: 0,
        loading: false,
        loadMore: true,
      };
    } else {
      currentListState = patients[listType] || {
        page: 0,
        loading: false,
        loadMore: true,
      };
    }

    const page = currentListState.page || 0;

    //devLog("[patientsSaga] Current list state:", {
    //  listType,
    //  queryId,
    //  loading: currentListState.loading,
    //  loadMore: currentListState.loadMore,
    //  page: page,
    //  searchCriteria: action.searchCriteria,
    //});

    // check if loadMore is true or already loading
    // Only prevent loading for pagination (page > 0) when loadMore is false
    // Always allow initial searches (page 0)
    if (
      !currentListState.loading &&
      "loadMore" in currentListState &&
      !currentListState.loadMore &&
      page > 0
    ) {
      // load more should not fire as loadMore is false and this is pagination
      //devLog(
      //  "[patientsSaga] Blocking pagination request - loadMore is false and page > 0"
      //);
      return false;
    }

    //devLog("[patientsSaga] Proceeding with API call...");

    // start loading more

    // put will set loading flag
    yield put({ type: LOAD_PATIENTS });
    // load patients

    try {
      //devLog(
      //  "[patientsSaga] Making API calls with searchCriteria:",
      //  action.searchCriteria
      //);
      // Execute both calls in parallel
      const [count, result] = yield all([
        call(PatientsService.loadCount, action.searchCriteria),
        call(PatientsService.load, page, action.searchCriteria),
      ]);

      //devLog("[patientsSaga] API calls completed:", {
      //  count,
      //  resultDataLength: result?.data?.length,
      //  loadMore: result?.loadMore,
      //});

      yield put({
        type: PATIENTS_LOADED,
        list: result.data,
        page: page + 1,
        loadMore: result.loadMore,
        total: count,
        criteria: action.searchCriteria,
      });
    } catch (error) {
      devLog("[patientsSaga] ERROR in API calls:", error);
      yield put({
        type: PATIENTS_LOADED,
        list: [],
        page: page + 1,
        loadMore: false,
        criteria: action.searchCriteria,
      });
    }
  }
}

export function* loadPatient() {
  while (true) {
    const action = yield take(LOAD_PATIENT);
    // put will set loading flag
    yield put({ type: LOAD_PATIENT });
    // load patients
    try {
      const id = action.id;
      // const loadSpaceDetails = action.loadSpaceDetails;
      const result = yield PatientsService.loadSingle(id);
      // if (loadSpaceDetails) {
      //   const spaceDetails = yield PatientsService.loadSpaceDetails(id);
      // }
      yield put({
        type: LOAD_PATIENT_DONE,
        data: result,
      });
    } catch (error) {
      devLog("ERROR", error);
    }
  }
}

export function* loadSavedSearches() {
  while (true) {
    const action = yield take(LOAD_SAVED_SEARCHES);

    try {
      const result = yield PatientsService.loadAllSavedSearches();
      // devLog('SAGE RESULT RETURNED ', result);
      yield put({
        type: SAVED_SEARCHES_LOADED,
        savedSearches: result,
      });
    } catch (error) {
      // devLog('SAGE RESULT ERROR ');
      yield put({
        type: SAVED_SEARCHES_LOADED,
        savedSearches: [],
      });
      devLog("ERROR", error);
    }
  }
}
